module.exports = __webpack_public_path__ + "images/business-class-feature-integration.ce5f8f256e6f3ccf9c53.png";